<script>
  import { asteroid, collections, Subscriber } from "@/meteor.js";
  import { onDestroy } from "svelte";
  import dayjs from 'dayjs'
  import 'dayjs/locale/da'
  dayjs.locale('da')
  
  export let route, routes, scoped;

  const {logs} = collections
  

  let _subscriptionId;
  const dictionary = {
    update: "opdaterede",
    insert: "indsatte",
    remove: "slettede",
    products: "produkt",
    users: "bruger"
  };

  function getQuery() {
    const query = {};
    const { collection, id } = route.params;
    console.log(query);
    if (collection === "user") query.userId = id;
    if (collection === "product") query.id = id;
    return query;
  }

  const subscribe = Subscriber()
  $: subscribe.setQuery('logs', getQuery())
  $subscribe
  
  

  // function subscribe() {
  //   if (_subscriptionId) asteroid.unsubscribe(_subscriptionId);
  //   const subscription = asteroid.subscribe("logs", getQuery());
  //   console.log(subscription)
  //   _subscriptionId = subscription.id;
  // }

  // subscribe();

  // onDestroy(() => {
  //   subscribe()
  //   // asteroid.unsubscribe(_subscriptionId);
  // });
</script>

<div class="absolute inset-0 flex justify-center">
  <div class="w-full sm:w-2/3">
    <h2 class="text-3xl">Log</h2>
    <ul>
      {#each Object.entries($logs) as [id, log]}
        <li>
          <div>
            <span>
              {dayjs(log.timeStamp.$date).format('DD-MM-YYYY HH:mm')}
            </span>
            <a href={'/users/' + log.userId}>
              <strong>{log.email}</strong>
            </a>
            {dictionary[log.action] || log.action} i {dictionary[log.collection] || log.collection}
            <a href={'/products/' + log.id}>
              <strong>{log.name}</strong>
            </a>
            : {JSON.stringify(log.document)}
          </div>
          <div />
        </li>
      {/each}

    </ul>
  </div>

</div>
<slot>
  <!-- Not used -->
</slot>
